import { render, staticRenderFns } from "./PrinterPluginDownloadModal.vue?vue&type=template&id=15fa74c2&scoped=true"
import script from "./PrinterPluginDownloadModal.vue?vue&type=script&lang=js"
export * from "./PrinterPluginDownloadModal.vue?vue&type=script&lang=js"
import style0 from "./PrinterPluginDownloadModal.vue?vue&type=style&index=0&id=15fa74c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa74c2",
  null
  
)

export default component.exports